import { Box } from '@interstate/components/Box';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { FC } from 'react';
import { MonthlyPaymentPeriod, MonthlyPaymentText, MonthlyPaymentValue } from './AiAltDealStructureSlideout.style';

interface MonthlyPaymentSectionProps {
    monthlyPayment: number | undefined;
}

export const MonthlyPaymentSection: FC<MonthlyPaymentSectionProps> = ({ monthlyPayment }) => {
    const theme = useInterstateTheme();

    return (
        <Box sx={{ textAlign: 'right' }}>
            <MonthlyPaymentText variant="body-xs" theme={theme}>
                MONTHLY PAYMENT
            </MonthlyPaymentText>
            <MonthlyPaymentValue theme={theme} variant="h2" data-testid="alt-deal-structure-monthly-payment">
                {formatDollarsAndCents(monthlyPayment)}
            </MonthlyPaymentValue>
            <MonthlyPaymentPeriod theme={theme} variant="body-xs">
                /month
            </MonthlyPaymentPeriod>
        </Box>
    );
};
